import { getAuthToken, Meta, Review } from "src/store/config";
import * as api from "./api";

interface ApiResponse {
  data: Review[];
  meta: Meta;
}

// fetch review list
export const fetchReviewList = async (data: {
  page: number;
  limit: number;
  // search?: string;
}): Promise<ApiResponse> => {
  const params: any = { page: data.page, limit: data.limit };

  // if (data.search && data.search.trim()) {
  //   params.search = data.search.trim();
  // }

  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/review`,
    params
  );
  return response;
};

// delete bad review
export const deleteReview = (ruid: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.remove(`${process.env.REACT_APP_ADMIN_API_URL}/review/${ruid}`);
};
